import React from 'react';
import MuiChip, { type ChipProps as MuiChipProps } from '@mui/material/Chip';

interface InputChipProps extends MuiChipProps {
  reverse?: boolean;
  selected?: boolean;
  error?: boolean;
  handleDelete: (event: any) => void;
}

export const InputChip = ({
  style,
  reverse = false,
  selected,
  error,
  handleDelete,
  ...rest
}: InputChipProps): JSX.Element => {
  const color = error ? 'error' : selected ? 'primary' : 'default';

  return (
    <MuiChip
      {...rest}
      style={{
        ...(reverse && { direction: 'rtl', paddingRight: '24px' }),
        ...style,
      }}
      color={color}
      onDelete={selected ? handleDelete : undefined}
    />
  );
};
